(function () {
    'use strict';

    angular
        .module('app.layout')
        .directive('spTopNav', spTopNav);

    spTopNav.$inject = ['opsIncludeVersion'];
    /* @ngInject */
    function spTopNav(opsIncludeVersion) {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/layout/sp-top-nav.html?v=' + opsIncludeVersion
        };

        return directive;
    }
})();
